/**
 * ProcurementScreen — List view + Form toggle wrapper for ALL procurement screens
 * Single entry point used by AppRouter for all 15 procurement transaction screens
 */
import React, { useState } from 'react';
import ERPAdvancedProcGrid from '../../../components/procurement/ERPAdvancedProcGrid';
import ProcurementForm from './ProcurementForm';
import { getProcConfig, DEMO_ROWS_BY_CATEGORY } from './procConfigs';

function blankRow(overrides = {}) {
  return {
    _id: Date.now() + Math.random(), gstType: 'excl',
    code:'', hsn:'', name:'', artCode:'', oemCode:'', uom:'',
    qty:'', rate:'', price:'', mrp:'', wsp:'', disc:'0', pn:'P',
    cgst:'2.50', sgst:'2.50', amount:'',
    division:'', dept:'', category:'', subcatg:'', brand:'', style:'',
    size:'', color:'', design:'', cref:'',
    smToken:'', commission:'0.00', scheme:'', batchNo:'', mfgDate:'', expiryDate:'', remarks:'',
    ...overrides,
  };
}

export default function ProcurementScreen({ screenId, theme, navigateTo }) {
  const cfg = getProcConfig(screenId);
  const [view,   setView]   = useState('list');
  const [editId, setEditId] = useState(null);

  // Demo rows for the form view (pre-populated for visual testing)
  const demoRows = (DEMO_ROWS_BY_CATEGORY[cfg.category] || []).map(r => blankRow(r));

  if (view === 'form') {
    return (
      <ProcurementForm
        screenId={screenId}
        demoRows={demoRows.length > 0 ? demoRows : undefined}
        onBack={() => { setView('list'); setEditId(null); }}
      />
    );
  }

  return (
    <ERPAdvancedProcGrid
      title={cfg.title}
      screenId={cfg.sid}
      columns={cfg.listCols}
      records={[]}
      onBack={navigateTo ? () => navigateTo('HUB') : undefined}
      onAddNew={() => setView('form')}
      onEdit={r => { setEditId(r.id || null); setView('form'); }}
      onView={r => { setEditId(r.id || null); setView('form'); }}
      onDelete={r => alert(`Delete ${r[cfg.listCols[0]?.field] || 'record'}?`)}
      onPrint={r => alert(`Print ${r[cfg.listCols[0]?.field] || 'record'}`)}
    />
  );
}
